import { Component, Input, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DATE_FORMATS, MatDateFormats } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { Moment } from 'moment';

export const MONTH_YEAR_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-ui-monthpicker',
  templateUrl: './ui-monthpicker.component.html',
  styleUrls: ['./ui-monthpicker.component.scss'],
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useValue: MONTH_YEAR_FORMATS,
    },
  ],
  standalone: false,
})
export class UiMonthpickerComponent implements OnInit, AfterViewInit {
  @Input() control: FormControl<Date | null>;
  /** Renders a suffix clear control before the calendar toggle (recommended for toolbar layouts). */
  @Input() allowClearSelection = false;
  @ViewChild('monthInput', { static: false }) monthInput: ElementRef<HTMLInputElement>;

  ngOnInit() {
    // Listen for value changes and format the display
    this.control.valueChanges.subscribe((value) => {
      this.updateInputDisplay(value);
    });
  }

  ngAfterViewInit() {
    // Initial formatting
    this.updateInputDisplay(this.control.value);
  }

  private updateInputDisplay(date: Date | null): void {
    if (!this.monthInput) {
      return;
    }
    if (!date) {
      this.monthInput.nativeElement.value = '';
      return;
    }
    const dateObj = date instanceof Date ? date : new Date(date);
    if (!Number.isNaN(dateObj.getTime())) {
      const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
      const year = dateObj.getFullYear().toString();
      this.monthInput.nativeElement.value = `${month}/${year}`;
    }
  }

  setMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Date>) {
    const selectedDate = normalizedMonthAndYear.toDate();
    const ctrlValue = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
    this.control.setValue(ctrlValue);
    datepicker.close();
  }

  clearSelectionClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.control.setValue(null);
  }
}
